<template>
  <div class="gallery-container">
    <!-- ==================== Logo 固定顶栏 ==================== -->
    <div class="top-nvb_box">
      <div class="top-nvb flex flex-col sm:flex-row sm:justify-center items-center pt-[15px] pb-[15px] sm:py-[20px]">
        <div class="logo-box">
          <img alt="" class="img" src="@/assets/img/logo.png" />
        </div>
      </div>
    </div>

    <!-- ==================== Banner 海报 ==================== -->
    <div
      class="top-banner h-[80vh] sm:h-[105vh] md:h-[700px] lg:h-[95vh] xl:h-[100vh] mt-[50px] sm:mt-[61px] relative overflow-hidden"
      id="section-gallery"
    >
      <!-- <div
        class="absolute top-[3rem] pr-[1rem] lg:top-[10%] left-[5%] lg:left-[7%] xl:left-[10%] text-[1.4rem] lg:text-[1.6rem] xl:text-[1.8rem] font-bold"
      ></div> -->
      <picture class="picture" style="">
        <source srcset="https://img.kamlung.net/v23AI/icaur_kv.jpg" media="(min-width: 768px)" />
        <source srcset="https://img.kamlung.net/v23AI/icaur_kv_2.jpg" media="(max-width: 769px)" />
        <img class="md:h-full" src="https://img.kamlung.net/v23AI/icaur_kv.jpg" loading="lazy" alt="" />
      </picture>
      <div
        class="max-w-[100%] sx:w-[450px] sm:w-[480px] absolute bottom-0 right-0 py-2 px-3 xs:py-3 xs:px-4 text-[#111] bg-[rgba(255,255,255,0.9)] flex flex-row items-center justify-between"
      >
        <div class="text-[12px] sm:text-[13px] mr-[10px] sx:mr-[4px] md:mr-[6px]">特別鳴謝：</div>
        <div class="h-[15px] sx:h-[20px] sm:h-[23px] mr-[10px] sx:mr-[4px] md:mr-[6px]">
          <img src="../assets/img/sponsorship/1.png" class="h-full !w-auto" />
        </div>
        <div class="h-[16px] sx:h-[23px] sm:h-[25px]">
          <img src="../assets/img/sponsorship/2.png" class="h-full !w-auto" />
        </div>
      </div>
    </div>

    <!-- ==================== 导航条 ==================== -->
    <nav-bar :items="navItems" />

    <!-- ==================== 作品排名 ==================== -->
    <div class="max-w-[1400px] w-[92%] m-auto pt-[40px] pb-[20px] md:pt-[60px] md:pb-[30px]" id="section-ranking1">
      <!-- <div class="text-[24px] font-bold">作品排名</div> -->
      <div
        class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000] mt-[40px] md:mt-[140px]"
      >
        <!-- 获奖公示 -->
        <img src="../assets/img/title/8888.png" class="w-[280px] md:w-[380px] m-auto z-10 relative" />
      </div>
      <!-- 作品项 -->
      <div class="mt-[100px]">
        <div class="w-full flex items-center justify-center">
          <img src="../assets/img/ranking/ranking_1.png" alt="" class="max-h-[270px] object-cover rounded-[8px]" />
        </div>
        <div class="flex flex-col mdd:flex-row items-center justify-center mt-[60px]">
          <div
            class="text-[14px] sm:text-[16px] font-bold mt-[40px] 2xl:mx-[50px] xl:mx-[36px] mdd:mx-[20px] mx-auto cursor-pointer"
            v-for="item in ranking1"
            :key="item.id"
            @click="openDetail(item)"
          >
            <div class="masonry__media relative" :class="{ 'is-ready': item.loaded || item.broken }">
              <img
                v-if="!item.broken"
                :src="item.workImageUrl"
                alt=""
                class="lazy-img w-full h-auto mdd:max-h-[400px] mdd:w-auto object-cover rounded-[4px] border-[6px] border-solid ranking_1"
                :class="{ 'is-loaded': item.loaded }"
                loading="lazy"
                @load="item.loaded = true"
                @error="item.broken = true"
              />
              <div v-else class="masonry__placeholder">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                  />
                </svg>
              </div>
              <div v-if="item.workMediaUrl && item.loaded" class="masonry__play-badge">
                <svg class="masonry__play-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              <div class="remark-badge" v-if="item.loaded">
                {{ item.remark }}
              </div>
            </div>
            <div class="text-[16px] sm:text-[18px] font-bold mt-3">
              創建者：{{ item.surname + ' ' }}{{ item.name }}（{{ item.title }}）
            </div>
            <div class="text-[16px] sm:text-[18px] font-bold mt-1">組別：{{ item.groupName }}</div>
          </div>
        </div>
      </div>

      <div class="mt-[200px]">
        <div class="w-full flex items-center justify-center">
          <img src="../assets/img/ranking/ranking_2.png" alt="" class="max-h-[270px] object-cover rounded-[8px]" />
        </div>
        <div class="flex flex-col mdd:flex-row items-center justify-center mt-[60px]">
          <div
            class="text-[14px] sm:text-[16px] font-bold mt-[40px] 2xl:mx-[50px] xl:mx-[36px] mdd:mx-[20px] mx-auto cursor-pointer"
            v-for="item in ranking2"
            :key="item.id"
            @click="openDetail(item)"
          >
            <div class="masonry__media relative" :class="{ 'is-ready': item.loaded || item.broken }">
              <img
                v-if="!item.broken"
                :src="item.workImageUrl"
                alt=""
                class="lazy-img w-full h-auto mdd:max-h-[400px] mdd:w-auto object-cover rounded-[4px] border-[6px] border-solid ranking_2"
                :class="{ 'is-loaded': item.loaded }"
                loading="lazy"
                @load="item.loaded = true"
                @error="item.broken = true"
              />
              <div v-else class="masonry__placeholder">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                  />
                </svg>
              </div>
              <div v-if="item.workMediaUrl && item.loaded" class="masonry__play-badge">
                <svg class="masonry__play-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              <div class="remark-badge" v-if="item.loaded">
                {{ item.remark }}
              </div>
            </div>
            <div class="text-[16px] sm:text-[18px] font-bold mt-3">
              創建者：{{ item.surname + ' ' }}{{ item.name }}（{{ item.title }}）
            </div>
            <div class="text-[16px] sm:text-[18px] font-bold mt-1">組別：{{ item.groupName }}</div>
          </div>
        </div>
      </div>

      <div class="mt-[200px]">
        <div class="w-full flex items-center justify-center">
          <img src="../assets/img/ranking/ranking_3.png" alt="" class="max-h-[270px] object-cover rounded-[8px]" />
        </div>
        <div class="flex flex-col mdd:flex-row items-center justify-center mt-[60px]">
          <div
            class="text-[14px] sm:text-[16px] font-bold mt-[40px] 2xl:mx-[50px] xl:mx-[36px] mdd:mx-[20px] mx-auto cursor-pointer"
            v-for="item in ranking3"
            :key="item.id"
            @click="openDetail(item)"
          >
            <div class="masonry__media relative" :class="{ 'is-ready': item.loaded || item.broken }">
              <img
                v-if="!item.broken"
                :src="item.workImageUrl"
                alt=""
                class="lazy-img w-full h-auto mdd:max-h-[400px] mdd:w-auto object-cover rounded-[4px] border-[6px] border-solid ranking_3"
                :class="{ 'is-loaded': item.loaded }"
                loading="lazy"
                @load="item.loaded = true"
                @error="item.broken = true"
              />
              <div v-else class="masonry__placeholder">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                  />
                </svg>
              </div>
              <div v-if="item.workMediaUrl && item.loaded" class="masonry__play-badge">
                <svg class="masonry__play-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              <div class="remark-badge" v-if="item.loaded">
                {{ item.remark }}
              </div>
            </div>
            <div class="text-[16px] sm:text-[18px] font-bold mt-3">
              創建者：{{ item.surname + ' ' }}{{ item.name }}（{{ item.title }}）
            </div>
            <div class="text-[16px] sm:text-[18px] font-bold mt-1">組別：{{ item.groupName }}</div>
          </div>
        </div>
      </div>

      <div class="mt-[200px]">
        <div class="w-full flex items-center justify-center">
          <img src="../assets/img/ranking/ranking_4.png" alt="" class="max-h-[270px] object-cover rounded-[8px]" />
        </div>
        <div class="flex w-full mdd-w-auto flex-row flex-wrap items-center justify-between md:justify-center mt-[60px]">
          <div
            class="w-[46%] sm:w-[46%] mdd:w-[30%] text-[14px] sm:text-[16px] font-bold mt-[40px] sm:mx-[10px] mdd:mx-[20px] mx-[4px] cursor-pointer"
            v-for="item in ranking4_1"
            :key="item.id"
            @click="openDetail(item)"
          >
            <!-- h-auto mdd:max-h-[200px] -->
            <div class="masonry__media relative" :class="{ 'is-ready': item.loaded || item.broken }">
              <img
                v-if="!item.broken"
                :src="item.workImageUrl"
                alt=""
                class="lazy-img max-w-[100%] mdd:w-[100%] object-cover rounded-[4px] border-[6px] border-solid ranking_4"
                :class="{ 'is-loaded': item.loaded }"
                loading="lazy"
                @load="item.loaded = true"
                @error="item.broken = true"
              />
              <div v-else class="masonry__placeholder">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                  />
                </svg>
              </div>
              <div v-if="item.workMediaUrl && item.loaded" class="masonry__play-badge">
                <svg class="masonry__play-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              <div class="remark-badge" v-if="item.loaded">
                {{ item.remark }}
              </div>
            </div>
            <div class="text-[16px] sm:text-[18px] font-bold mt-3">
              創建者：{{ item.surname + ' ' }}{{ item.name }}（{{ item.title }}）
            </div>
            <div class="text-[16px] sm:text-[18px] font-bold mt-1">組別：{{ item.groupName }}</div>
          </div>
        </div>
        <div class="flex w-full mdd-w-auto flex-row flex-wrap items-center justify-between md:justify-center mt-[60px]">
          <div
            class="w-[46%] sm:w-[46%] mdd:w-[30%] text-[14px] sm:text-[16px] font-bold mt-[40px] sm:mx-[10px] mdd:mx-[20px] mx-[4px] cursor-pointer"
            v-for="item in ranking4_2"
            :key="item.id"
            @click="openDetail(item)"
          >
            <!-- h-auto mdd:max-h-[200px] -->
            <div class="masonry__media relative" :class="{ 'is-ready': item.loaded || item.broken }">
              <img
                v-if="!item.broken"
                :src="item.workImageUrl"
                alt=""
                class="lazy-img max-w-[100%] mdd:w-auto object-cover rounded-[4px] border-[6px] border-solid ranking_4"
                :class="{ 'is-loaded': item.loaded }"
                loading="lazy"
                @load="item.loaded = true"
                @error="item.broken = true"
              />
              <div v-else class="masonry__placeholder">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                  />
                </svg>
              </div>
              <div v-if="item.workMediaUrl && item.loaded" class="masonry__play-badge">
                <svg class="masonry__play-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              <div class="remark-badge" v-if="item.loaded">
                {{ item.remark }}
              </div>
            </div>
            <div class="text-[16px] sm:text-[18px] font-bold mt-3">
              創建者：{{ item.surname + ' ' }}{{ item.name }}（{{ item.title }}）
            </div>
            <div class="text-[16px] sm:text-[18px] font-bold mt-1">組別：{{ item.groupName }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== 作品详情弹窗 ==================== -->
    <transition name="fade">
      <div v-if="detailVisible" class="detail-overlay" @click.self="closeDetail">
        <div class="detail-modal">
          <!-- 关闭按钮 -->
          <button class="detail-close" @click="closeDetail">
            <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              />
            </svg>
          </button>

          <!-- 媒体区域 -->
          <div class="detail-media">
            <img
              v-if="currentItem.workImageUrl"
              :src="currentItem.workImageUrl"
              :alt="currentItem.title"
              class="detail-img"
              title="點擊放大"
              @click.stop="openPreview(currentItem.workImageUrl)"
            />
            <video
              v-if="currentItem.workMediaUrl"
              ref="detailVideo"
              :src="currentItem.workMediaUrl"
              class="detail-video"
              controls
              playsinline
            ></video>
          </div>

          <!-- 信息区域 -->
          <div class="detail-body">
            <h2 class="detail-title">{{ currentItem.description || currentItem.title }}</h2>

            <div class="detail-info" style="margin-bottom: 10px">
              <div>創建者：{{ currentItem.surname + ' ' }}{{ currentItem.name }}（{{ currentItem.title }}）</div>
              <div>
                參賽組別：
                <span
                  class="detail-group"
                  :class="currentItem.groupName === '學生組' ? 'detail-group--blue' : 'detail-group--green'"
                >
                  {{ currentItem.groupName }}
                </span>
              </div>
            </div>
            <div class="detail-info" style="margin-bottom: 30px">vID：{{ currentItem.remark }}</div>
          </div>
        </div>
      </div>
    </transition>

    <!-- ==================== 图片放大预览 ==================== -->
    <transition name="fade">
      <div v-if="previewVisible" class="preview-overlay" @click="closePreview">
        <img
          :src="previewUrl"
          alt=""
          class="preview-img"
          :style="previewTransform"
          @click.stop
          @touchstart="onPreviewTouchStart"
          @touchmove.prevent="onPreviewTouchMove"
          @touchend="onPreviewTouchEnd"
        />
        <button class="preview-close" @click="closePreview">
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg>
        </button>
      </div>
    </transition>

    <footer-page></footer-page>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import FooterPage from '@/components/FooterPage.vue'
import { workListByGroupApi } from '@/Api/requestApi'

export default {
  name: 'GalleryRanking',
  components: {
    NavBar,
    FooterPage,
  },
  data() {
    return {
      loading: false,
      works: [],

      selectedGroups: ['學生組', '公開組'],
      groupOptions: [
        { key: '學生組', label: '學生組', color: '#1976d2' },
        { key: '公開組', label: '公開組', color: '#388e3c' },
      ],
      rankingList: [],
      ranking1: [],
      ranking2: [],
      ranking3: [],
      ranking4_1: [],
      ranking4_2: [],
      columnCount: 4,
      detailVisible: false,
      currentItem: {},
      previewVisible: false,
      previewUrl: '',
      previewScale: 1,
      previewX: 0,
      previewY: 0,
      navItems: [
        { key: 'home', label: '首頁', target: '#section-banner', href: '/' },
        { key: 'process', label: '賽事進程', target: '#section-process', href: '/' },
        { key: 'intro', label: '活動條款及細則', target: '#section-intro', href: '/' },
        { key: 'reference', label: '作品參考', target: '#section-reference', href: '/' },
        // { key: 'reference', label: '作品參考', target: '#section-reference', href: '/' },
        // { key: 'registration', label: '上傳作品', target: '#registration', href: '/' },
        { key: 'gallery', label: '入圍作品', target: '#section-gallery1', href: '/gallery' },
        { key: 'ranking', label: '獲獎公示', target: '#section-ranking1', href: '/ranking' },
      ],
    }
  },
  computed: {
    // 预览图手势变换
    previewTransform() {
      return {
        transform: `translate(${this.previewX}px, ${this.previewY}px) scale(${this.previewScale})`,
      }
    },
  },
  mounted() {
    this.rankingFetchWorks()
    // this.updateColumnCount()
    // window.addEventListener('resize', this.updateColumnCount)
    this.$nextTick(() => {
      this.scrollToGallery()
    })
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.updateColumnCount)
  },
  methods: {
    scrollToGallery() {
      const el = document.getElementById('section-gallery1')
      if (el) {
        const top = el.getBoundingClientRect().top + window.pageYOffset
        window.scrollTo({ top, behavior: 'instant' })
      }
    },
    // ==================== API 调用 ====================
    async rankingFetchWorks(reset = true) {
      if (reset) this.page = 1
      this.loading = true
      try {
        const res = await workListByGroupApi({})
        const data = res.data.data
        this.rankingList = data
        // 从「公開組」与「學生組」中筛出排名作品，并附上懒加载状态
        this.ranking1 = []
        this.ranking2 = []
        this.ranking3 = []
        this.ranking4_1 = []
        this.ranking4_2 = []
        this.selectedGroups.forEach((group) => {
          const list = this.rankingList[group] || []
          list.forEach((item) => {
            // loaded: 图片加载完成；broken: 图片加载失败（懒加载占位用）
            const work = { ...item, loaded: false, broken: false }
            if (Number(item.ranking) == 1) {
              this.ranking1.push(work)
            }
            if (Number(item.ranking) == 2) {
              this.ranking2.push(work)
            }
            if (Number(item.ranking) == 3) {
              this.ranking3.push(work)
            }
            if (Number(item.ranking) == 4 && item.groupName === '學生組') {
              this.ranking4_1.push(work)
            }
            if (Number(item.ranking) == 4 && item.groupName === '公開組') {
              this.ranking4_2.push(work)
            }
          })
        })

        console.log(this.ranking1)
      } catch (e) {
        console.error('獲取作品列表失敗', e)
      } finally {
        this.loading = false
      }
    },
    loadMore() {
      this.page++
      // this.fetchWorks(false)
    },

    // ==================== 详情弹窗 ====================
    openDetail(item) {
      // TODO: 后续替换为请求详情接口
      // const detail = await getWorkDetailApi(item.id)
      this.currentItem = { ...item }
      this.detailVisible = true
      // 禁止背景滚动
      document.body.style.overflow = 'hidden'
    },
    closeDetail() {
      this.detailVisible = false
      document.body.style.overflow = ''
      if (this.$refs.detailVideo) {
        this.$refs.detailVideo.pause()
      }
    },

    // ==================== 图片放大预览 ====================
    openPreview(url) {
      if (!url) return
      this.previewUrl = url
      this.previewVisible = true
      this.resetPreviewTransform()
    },
    closePreview() {
      this.previewVisible = false
      this.resetPreviewTransform()
    },
    resetPreviewTransform() {
      this.previewScale = 1
      this.previewX = 0
      this.previewY = 0
    },

    // ==================== 预览图手势（双指缩放 / 单指拖动 / 双击切换） ====================
    getTouchDistance(touches) {
      const dx = touches[0].clientX - touches[1].clientX
      const dy = touches[0].clientY - touches[1].clientY
      return Math.sqrt(dx * dx + dy * dy)
    },
    onPreviewTouchStart(e) {
      if (e.touches.length === 2) {
        this._previewTouch = {
          type: 'pinch',
          startDist: this.getTouchDistance(e.touches),
          startScale: this.previewScale,
        }
      } else if (e.touches.length === 1 && this.previewScale > 1) {
        this._previewTouch = {
          type: 'pan',
          startX: e.touches[0].clientX,
          startY: e.touches[0].clientY,
          originX: this.previewX,
          originY: this.previewY,
          moved: false,
        }
      } else {
        this._previewTouch = { type: 'tap', moved: false }
      }
    },
    onPreviewTouchMove(e) {
      const t = this._previewTouch
      if (!t) return
      if (t.type === 'pinch' && e.touches.length === 2) {
        const dist = this.getTouchDistance(e.touches)
        this.previewScale = Math.min(5, Math.max(1, (t.startScale * dist) / t.startDist))
      } else if (t.type === 'pan' && e.touches.length === 1) {
        const dx = e.touches[0].clientX - t.startX
        const dy = e.touches[0].clientY - t.startY
        if (Math.abs(dx) > 5 || Math.abs(dy) > 5) t.moved = true
        this.previewX = t.originX + dx
        this.previewY = t.originY + dy
      }
    },
    onPreviewTouchEnd(e) {
      const t = this._previewTouch
      // 手势结束后若缩小到最小则复位
      if (e.touches.length === 0) {
        if (this.previewScale <= 1) {
          this.resetPreviewTransform()
        }
        // 双击切换放大/还原
        if (t && t.type === 'tap' && !t.moved) {
          const now = Date.now()
          if (now - (this._lastTapTime || 0) < 300) {
            if (this.previewScale > 1) {
              this.resetPreviewTransform()
            } else {
              this.previewScale = 2
            }
            this._lastTapTime = 0
          } else {
            this._lastTapTime = now
          }
        }
        this._previewTouch = null
      } else if (e.touches.length === 1 && t && t.type === 'pinch') {
        // 双指变单指时切换为拖动
        this._previewTouch = {
          type: 'pan',
          startX: e.touches[0].clientX,
          startY: e.touches[0].clientY,
          originX: this.previewX,
          originY: this.previewY,
          moved: true,
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// ==================== 编号徽章 ====================
.remark-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 34px;
  height: 34px;
  border-radius: 100px;
  background: #1a1a1a;
  border: 2px solid #1a1a1a;
  color: #f48e30;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 4px rgba(255, 255, 255, 0.3);
  z-index: 2;

  @media (min-width: 768px) {
    width: 44px;
    height: 44px;
    font-size: 18px;
    top: 14px;
    left: 14px;
  }
}

// ==================== 图片懒加载 ====================
.masonry__media {
  position: relative;
  line-height: 0;
  background: linear-gradient(110deg, #f2f3f5 8%, #e9ebee 18%, #f2f3f5 33%);
  background-size: 200% 100%;
  animation: masonry-shimmer 1.2s linear infinite;

  // 未加载完成前保持默认比例占位
  &:not(.is-ready) {
    aspect-ratio: 4 / 3;
  }

  &.is-ready {
    animation: none;
    background: #f2f3f5;
  }
}

@keyframes masonry-shimmer {
  to {
    background-position: -200% 0;
  }
}

// 图片淡入
.lazy-img {
  opacity: 0;
  transition: opacity 0.3s ease;

  &.is-loaded {
    opacity: 1;
  }
}

// 加载失败默认占位
.masonry__placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;

  svg {
    width: 32px;
    height: 32px;
  }
}

.ranking_1 {
  border-color: #d9a344;
}
.ranking_2 {
  border-color: #929497;
}
.ranking_3 {
  border-color: #de9366;
}
.ranking_4 {
  border-color: #467dc9;
}

// ==================== Header 样式（与 HomeView 一致） ====================
.top-nvb_box {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  border-bottom: #cccccc8c solid 1px;
  z-index: 1000;
  backdrop-filter: blur(10px);
  background-color: #fafafab3 !important;

  .top-nvb {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;

    .logo-box {
      max-width: 120px;
    }
  }
}

.top-banner {
  width: 100%;

  img {
    display: block;
    width: 100%;
    object-fit: cover;
  }
}

// 视频播放徽标
.masonry__play-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.75);
  }

  @media (min-width: 768px) {
    width: 44px;
    height: 44px;
    top: 18px;
    right: 18px;
  }
}

.masonry__play-icon {
  width: 14px;
  height: 14px;
  color: #fff;
  margin-left: 2px;

  @media (min-width: 768px) {
    width: 20px;
    height: 20px;
  }
}

// 底部信息
.masonry__info {
  padding: 10px 12px 12px;
}

.masonry__title {
  font-size: 13px;
  font-weight: 600;
  color: #222;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 6px;

  @media (min-width: 640px) {
    font-size: 14px;
  }
}

.masonry__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.masonry__author {
  font-size: 12px;
  color: #999;
}

.masonry__group {
  font-size: 11px;
  color: #fff;
  padding: 1px 8px;
  border-radius: 10px;

  &--blue {
    background: #e3f2fd;
    color: #1976d2;
  }

  &--green {
    background: #e8f5e9;
    color: #388e3c;
  }
}

.masonry__author-icon {
  color: #bbb;
}

.masonry__like-icon {
  color: #e74c3c;
}

// ==================== 详情弹窗 ====================
.detail-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.detail-modal {
  position: relative;
  width: 98%;
  max-width: 700px;
  max-height: 95vh;
  background: #fff;
  border-radius: 12px;
  overflow-y: auto;
  margin: 16px;
  display: flex;
  flex-direction: column;

  @media (max-width: 639px) {
    margin: 0;
    max-height: 100vh;
    border-radius: 0;
    max-width: 100%;
  }
}

.detail-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.75);
  }

  @media (max-width: 639px) {
    top: 8px;
    right: 8px;
    width: 32px;
    height: 32px;
  }
}

.detail-media {
  width: 100%;
  line-height: 0;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.detail-img {
  width: 100%;
  display: block;
  cursor: zoom-in;
}

.detail-video {
  width: 100%;
  outline: none;
  display: block;
}

.detail-body {
  padding: 20px;

  @media (min-width: 640px) {
    padding: 28px 32px;
  }
}

.detail-title {
  font-size: 16px;
  font-weight: 700;
  color: #222;
  margin: 0 0 14px;
  line-height: 1.5;

  @media (min-width: 640px) {
    font-size: 18px;
  }
}

.detail-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 16px;
}

.detail-stat {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #888;

  svg {
    flex-shrink: 0;
  }

  @media (min-width: 640px) {
    font-size: 14px;
  }
}

.detail-desc {
  font-size: 14px;
  line-height: 1.8;
  color: #555;
  margin: 0;

  @media (min-width: 640px) {
    font-size: 15px;
  }
}

.detail-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #555;

  @media (min-width: 640px) {
    flex-direction: row;
    gap: 20px;
    font-size: 15px;
  }
}

.detail-group {
  display: inline-block;
  font-size: 11px;
  color: #fff;
  padding: 1px 8px;
  border-radius: 10px;
  vertical-align: middle;
  margin-left: 4px;

  &--blue {
    background: #e3f2fd;
    color: #1976d2;
  }

  &--green {
    background: #e8f5e9;
    color: #388e3c;
  }
}

// ==================== 图片放大预览 ====================
.preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}

.preview-img {
  max-width: 92vw;
  max-height: 92vh;
  object-fit: contain;
  cursor: default;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
  will-change: transform;
}

.preview-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
}

// ==================== 淡入淡出 ====================
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
